// extracted by mini-css-extract-plugin
export default {"caption":"ResearcherSection_caption__ewOEb","options":"ResearcherSection_options__k+MNM","root":"ResearcherSection_root__4Nz9y"};